import { useState, useEffect, React } from "react";
import $ from 'jquery';
// core components
import './Events.css';
import Footer from "../Footer/Footer.js";
import Loader from "../../components/loader/loader.js";
import Events_img from "../../assets/images/Events_img.jpg"


import Events from "../../assets/images/events.jpg"
import Chess from "../../assets/images/Chess.jpg"
import Diwali from "../../assets/images/diwali.png"
import Pongal from "../../assets/images/pongal.png"
import News from "../../assets/images/news.jpg"
import {Link} from "react-router-dom";

export default function Home() {
   const [loading, setLoading] = useState(true);
 
   useEffect(() => {
     const timer = setTimeout(() => {
       setLoading(false);
     }, 2500); 
 
     return () => clearTimeout(timer);
   }, []);
   $(window).scroll(function () {
    if ($(this).scrollTop()) {
      $('header').addClass('fixedTop');
    } else {
      $('header').removeClass('fixedTop');
    }
  });
  useEffect(() => {
     window.scrollTo(0, 0)
   }, [])
  return (
<div>
{loading ? <Loader /> :
    <div>
        <div className="vision_header">
          <section className="vision_banner">
            <div className="container-fluid custom-container">
               <div className="row">
                  <div className="col-md-6 col-sm-12 col-12">
                     <div className="vision_banner_text">
                        <h1>EVENTS</h1>
                       </div>
                  </div>
                  <div className="col-md-6 col-sm-12 col-12">
                     <div className="vision_banner_img">
                     <img src={Events_img} alt="Events_img" className="img-fluid"/>
                     </div>
                  </div>
               </div>
               </div>
            
                  
            </section>
             <section className="Eventus mt-4 pt-5">
            <div className="container-fluid custom_container">
                <h2>Recent Events at Jayam Charitable Trust</h2>
                  <div className="row">
                  <div className="col-lg-4 col-md-6 col-12">
                   <div className="event_card">
                     <div className="event_img">
                        <img src={Events} alt="events" />
                     </div>
                     <div className="event_content">
                      <div>
                        <h5>4 Oct 2024</h5>
                        </div>
                        <h3>🌟 ARMADHAM '24 – A Grand Celebration of History, Culture, and Light 🌟</h3>
                        <p>On October 4, 2024, Indira Gandhi Medical College and Research Centre, Pondicherry, in collaboration with Jayam Charitable Trust, proudly celebrated ARMADHAM '24 an unforgettable evening that brought together heritage, music, and student spirit.</p>
                        <p>The event was beautifully organised by Ms. A. Mahadhi, MBBS 2nd Year, whose dedication and vision brought every element of the celebration to life.</p>
                        <p>The highlight of the evening was the recreation of the Vaman Avatar’s historical journey, powerfully narrated by Dr. R. Sivakumar, IPS, capturing hearts with his storytelling.</p>
                        <p>Soulful melodies by Music Director P.C. Sivan, a stunning light and sound show, and vibrant cultural performances by the students turned the celebration into a festival of light, emotion, and togetherness.</p>
                        <p>Jayam Charitable Trust was honoured to be a part of this grand event in Pondicherry, where tradition met youthful enthusiasm in the most spectacular way.</p>
                        <p>This wasn’t just a celebration  it was a night of heritage, harmony, and heartfelt memories.</p>
                        <p>With gratitude,</p>
                        <p>Jayam Charitable Trust</p>
                       </div>

                   </div>
                  </div>
                  {/* <div className="col-lg-4 col-md-6 col-12">
                   <div className="event_card">
                     <div className="event_img">
                        <img src={Medical} alt="events" />
                     </div>
                     <div className="event_content">
                        <div>
                        <h5>15 June2025</h5>
                        </div>
                        <h3>Medical Camp Services</h3>
                        </div>

                   </div>
                  </div> */}
                  <div className="col-lg-4 col-md-6 col-12">
                   <div className="event_card">
                     <div className="event_img">
                        <img src={Pongal} alt="events" />
                     </div>
                     <div className="event_content">
                          <div>
                        <h5>15 Jan 2025</h5>
                        </div>
                        <h3>🌾 Pongal 2025 – A Celebration of Light, Love, and Humanity 🌾</h3>
                        <p>This Pongal, Jayam Charitable Trust experienced a festival like no other not through grand decorations or feasts, but through the sparkling smiles and joyful hearts of a group of incredible young girls who are visually challenged.</p>
                        <p>In a world they may not see, they taught us how to truly feel with every laugh, every touch, every hug. As we gifted them new dresses and celebrated the harvest of hope and togetherness, they gifted us something far greater: pure love and unbreakable spirit.</p>
                        <p>We are profoundly grateful to Dr. S. Venkatarajalu and Dr. Nirmala for gracing us with their presence. Your warmth and encouragement made the day even more special a reminder that true kindness is felt in actions, not just words.</p>
                        <p>This wasn’t just a celebration of Pongal it was a reminder that small acts of love can light up even the darkest world.</p>
                        <p>May we carry this light forward, always. 💛</p>
                        <p>With heartfelt gratitude,</p>
                        <p>Jayam Charitable Trust</p>
                        </div>

                   </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-12">
                   <div className="event_card">
                     <div className="event_img">
                        <img src={Chess} alt="events" />
                     </div>
                     <div className="event_content">
                          <div>
                        <h5>15 Jun 2025</h5>
                        </div>
                        <h3>State Level Chess Competition</h3>
                        <p>Jayam Charitable Trust, in association with Radical Chess Academy, successfully organized the State Level Chess Competition at Kalashetra Matriculation School, Kattupakkam. The event was made possible through the generous support of various sponsoring companies. Their contributions not only enabled a well-organized tournament but also extended direct benefit to the Trust, helping JCT further its charitable initiatives and community outreach programs.</p>
                       
                        </div>

                   </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-12">
                   <div className="event_card">
                     <div className="event_img">
                        <img src={News} alt="news" />
                     </div>
                     <div className="event_content">
                          <div>
                        {/* <h5>31 Oct 2024</h5> */}
                        </div>
                        <h3>✨ World Senior Citizen Day ✨</h3>
                        <p>Every year on 21st August, the world comes together to honor the contributions of senior citizens. At Jayam Charitable Trust, we proudly celebrate World Senior Citizen Day in the name of Ex-MLA Kumari Anandhan, a leader who dedicated his life to the service of people and continues to inspire us.
</p>
                        <p>Adding to the joy, Actress Priya Dharshini generously contributed with a ₹10,000 cheque, lighting up the occasion not just with her presence, but with her heartfelt support.</p>
                        <p className="ourpurposenews">🙏 Our Purpose
                          <ul>
                            <li>Through this celebration, we aim to:</li>
                            <li>Recognize the wisdom, experience, and sacrifices of elders.</li>
                            <li>Promote awareness about senior citizen health, well-being, and dignity.</li>
                            <li>Build bridges between generations through respect, care, and compassion.</li>
                          </ul>
                        </p>
                        <p className="ourpurposenews">🎉 Celebration Highlights
                          <ul>
                            <li>On this special day, Jayam Charitable Trust organizes meaningful activities such as:</li>
                            <li>Cultural programs to showcase talent and encourage participation.</li>
                            <li>Felicitation ceremonies honoring the contributions of elders.</li>
                            <li>Community bonding events where youth interact and learn from seniors.</li>
                          </ul>
                        </p>
                        <p className="ourpurposenews">❤️ Our Commitment
                          <ul>
                            <li>At Jayam Charitable Trust, inspired by the values of Ex-MLA Kumari Anandhan, we pledge to ensure that senior citizens live with respect, comfort, and joy.</li>
                            <li>This World Senior Citizen Day, let’s come together to make our elders feel valued—not just for a day, but every single day.</li>
            
                          </ul>
                        </p>
                        
                       
                        </div>

                   </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-12">
                   <div className="event_card">
                     <div className="event_img">
                        <img src={Diwali} alt="events" />
                     </div>
                     <div className="event_content">
                          <div>
                        <h5>31 Oct 2024</h5>
                        </div>
                        <h3>✨ Diwali 2024 – A Spark of Light and Generosity ✨</h3>
                        <p>This Diwali 2024, the celebration shone brighter through acts of kindness and love. Jayam Charitable Trust had the privilege of sharing joy with Ms. Sangeeta, a visually challenged young girl, by gifting her new clothes and warm wishes for a brighter tomorrow.
</p>
                        <p>Adding to the joy, Actress Priya Dharshini generously contributed with a ₹10,000 cheque, lighting up the occasion not just with her presence, but with her heartfelt support.</p>
                        <p>We are also deeply thankful to Mr. Arivalagan and Mr. Khaja Khadeeruddin, whose presence and involvement played a significant role in making this event truly special. Your kindness and encouragement are the true spirit of Diwali spreading light where it’s needed most.</p>
                        <p>This wasn't just a festival of lights it was a celebration of hope, compassion, and togetherness.</p>
                        <p>With deep gratitude,</p>
                        <p>Jayam Charitable Trust</p>
                       
                        </div>

                   </div>
                  </div>
                 
               </div>
                  
                
                  
              
            </div>         
           </section>
                  
           <Footer />
        </div>
     
    </div>
    }
    </div>
  )
}
